/**
 * DetailRelatedContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled detail related container.
 */
const DetailRelatedContainer = styled.div<React.CSSProperties>`
  position: relative;
  top: ${432 * Screen.widthRatio}px;
`;

export default DetailRelatedContainer;
